export default [
  {
    id: 1,
    name: 'Substandard 32w',
    description: 'Substandard',
    code: 1,
    is_published: true,
    order_num: 1,
    details: {
      _translated: {
        en_GB: {
          name: 'Substandard',
          description: 'Substandard',
        },
        en_US: {
          name: 'Substandard',
          description: 'Substandard',
        },
        es_ES: {
          name: 'Subestándar',
          description: 'Subestándar',
        },
        es_MX: {
          name: 'Subestándar',
          description: 'Subestándar',
        },
      },
    },
  },
  {
    id: 2,
    name: 'Without Housing',
    description: 'Without or Soon to Be Without Housing',
    code: 2,
    is_published: true,
    order_num: 2,
    details: {
      _translated: {
        en_GB: {
          name: 'Without Housing',
          description: 'Without or Soon to Be Without Housing',
        },
        en_US: {
          name: 'Without Housing',
          description: 'Without or Soon to Be Without Housing',
        },
        es_ES: {
          name: 'Sin alojamiento',
          description: 'Sin o pronto sin alojamiento',
        },
      },
    },
  },
  {
    id: 3,
    name: 'Standard',
    description: 'Standard',
    code: 3,
    is_published: true,
    order_num: 3,
    details: {
      _translated: {
        en_GB: {
          name: 'Standard',
          description: 'Standard',
        },
        en_US: {
          name: 'Standard',
          description: 'Standard',
        },
        es_ES: {
          name: 'Estándar',
          description: 'Estándar',
        },
        es_MX: {
          name: 'Estándar',
          description: 'Estándar',
        },
        fr_FR: {
          name: 'Standard',
          description: 'Standard',
        },
      },
    },
  },
  {
    id: 4,
    name: 'Conventional',
    description: 'Conventional Public Housing',
    code: 4,
    is_published: true,
    order_num: 4,
    details: {
      _translated: {
        en_GB: {
          name: 'Conventional',
          description: 'Conventional Public Housing',
        },
        en_US: {
          name: 'Conventional',
          description: 'Conventional Public Housing',
        },
        es_ES: {
          name: 'Convencional',
          description: 'Vivienda pública convencional',
        },
      },
    },
  },
  {
    id: 5,
    name: 'No Nighttime Residence',
    description: 'Lacking a Fixed Nighttime Residence',
    code: 5,
    is_published: true,
    order_num: 5,
    details: {
      _translated: {
        en_GB: {
          name: 'No Night-time Residence',
          description: 'Lacking a Fixed Nighttime Residence',
        },
        en_US: {
          name: 'No Nighttime Residence',
          description: 'Lacking a Fixed Nighttime Residence',
        },
        es_ES: {
          name: 'Sin residencia nocturna',
          description: 'Falta una residencia nocturna fija',
        },
      },
    },
  },
  {
    id: 6,
    name: 'Fleeing Violence',
    description: 'Fleeing/Attempting to Flee Violence',
    code: 6,
    is_published: true,
    order_num: 6,
    details: {
      _translated: {
        en_GB: {
          name: 'Fleeing Violence',
          description: 'Fleeing/Attempting to Flee Violence',
        },
        en_US: {
          name: 'Fleeing Violence',
          description: 'Fleeing/Attempting to Flee Violence',
        },
        es_ES: {
          name: 'Evitación de la violencia',
          description: 'Evitando o intentando huir de la violencia',
        },
      },
    },
  },
];
